<template>
  <!-- top -->

  <div>
    <div class="head">
      <div class="banxin1">
        <div class="logo flex align-center">
          <img src="../assets/images/logo4.png" alt="" />
          <div>多彩畅行</div>
        </div>
        <div class="vice_logo">多彩畅行 服务随行</div>
      </div>
    </div>
    <div>
      <block>
        <img src="@/assets/images/banner.png" class="banner_img" alt="" />
      </block>
      <div class="w1200">
        <div class="flex space-between guide">
          <div class="guide_t">
            <div class="font-bold fs42">多彩畅行导游</div>
            <div class="flex align-center">
              <div class="flex align-end">
                <span class="font-bold fs36">8</span>
                <span class="fs18" style="margin: 0 0 8px 5px">0000</span>
                <span class="self-start fs20" style="margin-top: 5px">+</span>
              </div>
              <p class="gu_desc fs22">本地专业导游等你预约</p>
            </div>
          </div>
          <!-- <div class="xjt text-center">
            <p class="fs24">
              了解 <br />
              更多
            </p>
            <img src="@/assets/images/xjt.png" alt="" />
          </div> -->
        </div>
      </div>
      <div class="w1200">
        <img src="@/assets/images/ch_banner.png" class="chlid_banner_img" alt="" />
      </div>
      <div class="w1200 ad">
        <img src="@/assets/images/vdv.png" alt="">
      </div>
      <div class=" chuxing">
        <div class="w1200">
          <div class="guide_t">
            <div class="font-bold fs42">多彩畅行平台</div>
            <p class="gu_desc fs22" style="margin: 0;">多彩畅行 服务随行</p>
          </div>
        </div>
        <div style="background: #090A06;margin-top: 30px">
          <div class="w1200 flex align-center">
            <img src="@/assets/images/fdfd.png" alt="">
            <div class="dz_desc">
              <h3 class="fs24">定制游，一家一团，行程自由</h3>
              <h4 class="fs16">多彩畅行是专注为自由行客源提供旅游目的地用车+导游服务+旅行管家服务平台，致力于为国内游用户提供专业、舒心、安全、便捷、全面的导游和交通服务。</h4>
              <div class="fs16">
                <h6><span>→</span> 找个“司导”自由行</h6>
                <h6><span>→</span> 和多彩畅行一起，伴侣自由行</h6>
                <h6><span>→</span> 独立成团，单独用车，专享私人导游服</h6>
                <h6><span>→</span> 旅游网约车来了，司导合一服务约起来</h6>
                <h6><span>→</span> 一单一车,私密有保障,价格透明,纯玩纯享</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="download">
      <div class="red_box"></div>
      <div class="banxin2">
        <div class="phone">
          <img src="../assets/images/phone.png" alt="" />
        </div>
        <div class="download_main">
          <div class="box1"></div>
          <div class="text">
            <div class="text1">下载多彩畅行APP</div>
            <div class="text2">· 便捷预订</div>
            <div class="text2">· 行程/订单查询</div>
            <div class="text2">· 实时联系司导/向导</div>
            <div class="text2">· 客服24小时服务</div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="banxin3 flex space-between align-center">
        <div class="">
           <div>公司名称：贵州多彩行数字科技有限公司</div>
           <div>客服工作时间：9:00-18:00</div>
           <div>客服电话：18184569575</div>
        </div>
        <div>
          <img src="../assets/images/logo4.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {
      timer: null, // 滚动动画计时器
      stopScroll: true, // 取消滚动
      isOpacity: false, // 导航条是否透明
      childNav: [
        {
          img: "/src/assets/images/icon1.png",
          name: "本地活动",
        },
        {
          img: "/src/assets/images/icon2.png",
          name: "主题游",
        },
        {
          img: "/src/assets/images/icon3.png",
          name: "定制游",
        },
        {
          img: "/src/assets/images/icon4.png",
          name: "游记",
        },
        {
          img: "/src/assets/images/icon5.png",
          name: "旅游包车",
        },
        {
          img: "/src/assets/images/icon6.png",
          name: "定制客运",
        },]
    };
  },
  methods: {

  },
  created() { },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
};
</script>
<style scoped>
.head {
  width: 100vw;
  height: 100px;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 1000;
  background: transparent;
}

.banxin1 {
  width: 1200px;
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background: yellow; */
}

.nav {
  /* width: calc(100% - 340px); */
  /* display: flex;
  justify-content: space-around;
  align-self: center; */
}

.ant-menu-horizontal {
  line-height: 82px;
}

.nav ul {
  height: 82px;
  margin: auto;
}

.logo {
  font-size: 20px;
  font-weight: 700;
  color: #ff2929;
}

.logo img {
  width: 100px;
  height: 100px;
}

.vice_logo {
  font-size: 30px;
  font-weight: 700;
  color: #ff2929;
}

.ant-menu {
  color: #fff;
  background: transparent;
  border-bottom: none !important;
}



.childNav img {
  width: 39px;
  height: 39px;
}

.slick-slide img {
  display: inline-block !important;
}

.childNav {
  background: #f8f8f8;
  width: 100%;
}

.w1200 {
  width: 1200px;
  margin: 0 auto;
}

.child_cont {
  flex: 0 0 200px;
  height: 120px;
}

.child_cont:hover {
  background: #ffe7e6;
}

.child_cont>p {
  margin: 0;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}

.xjt p {
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #999999;
  margin-bottom: 15px;
  line-height: 30px;
}

.xjt img {
  width: 33px;
  height: 17px;
}

.guide {
  margin: 80px 0 40px 0;
}

.guide_t {
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #111111;
}

.guide_t>div span {
  color: #ff2929;
  font-family: Impact;
}

.gu_desc {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  margin: 0 0 0 10px;
}

.chlid_banner_img {
  width: 100%;
  height: 277px;
}


.ad img {
  width: 100%;
  height: 90px;
  margin: 60px 0;
}

.chuxing {
  width: 100%;
  padding: 55px 0;
}

.bg {
  background: #F8F8F8;
}

.car {
  width: 388px;
  height: 180px;
  margin-top: 30px;
}

.dz_desc {
  margin-left: 50px;
}

.dz_desc h4 {
  margin: 20px 0 60px 0;
}

.dz_desc h3,
.dz_desc h4,
.dz_desc h6 {
  color: white;
}

.dz_desc h6 span {
  margin-right: 15px;
}

.mdd {
  width: 300px;
  height: 460px;
}

.mdd_list_t {
  top: 0;
  left: 0;
  z-index: 1;
  padding: 0 30px 50px 30px;
  background: linear-gradient(to top, transparent, rgba(255, 0, 0, 0));
  color: white;
}

.mdd_list_t span:nth-child(2) {
  margin: 0 13px;
}

.day {
  color: white;

}



.download {
  /* width: 100vw; */
  height: 498px;
  margin-top: 100px;
  position: relative;
}

.red_box {
  width: 100%;
  height: 353px;
  position: absolute;
  left: 0;
  bottom: 0;
  /* z-index: -1; */
  background-color: hwb(0deg 27% 0%);
}

.banxin2 {
  width: 1200px;
  height: 100%;
  margin: auto;
  position: relative;
  color: #F8F8F8;
}

.download_main {
  width: 1200px;
  height: 353px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.phone {
  width: 1200px;
  height: 146px;
}

.phone img {
  width: 332px;
  height: 498px;
}

.download_main .box1 {
  width: 332px;
  height: 498px;
}

.download_main .text .text1 {
  font-size: 42px;
  color: #fff;
  font-weight: bold;
  margin-bottom: 33px;
}

.download_main .text .text2 {
  font-size: 22px;
  color: #fff;
  margin-top: 12px;
}

.code img {
  width: 235px;
  height: 235px;
}



.foot {
  /* width: 100vw; */
  height: 423px;
  position: sticky;
  top: 0;
  left: 0;
  background: #2f2f2f;
  z-index: 100;
  padding: 66px 0 52px;
}

.banxin3 {
  width: 1200px;
  height: 100%;
  margin: auto;
  color: #F8F8F8;
  line-height: 40px;
  /* background: yellow; */
}
.banxin3 img{
    width: 200px;
    height: 200px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ul {
  width: 448px;
  height: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 74px;
  border-left: 1px solid #1b1b1b;
  border-right: 1px solid #1b1b1b;
}

.ul ul {
  list-style: none;
  text-align: center;
  padding: 0;
  margin: 0;
}

.ul ul li {
  color: #999999;
  font-size: 14px;
  margin-bottom: 8px;
  cursor: pointer;
}

.ul ul li:hover {
  color: #fff !important;
}

.ul_box {
  height: 100%;
  text-align: center;
}

.ul_title {
  color: #fff;
  font-size: 18px;
  text-align: center;
  margin-bottom: 20px;
}

.codes .title {
  text-align: center;
  color: #ffffff;
  font-size: 18px;
  margin-bottom: 35px;
}

.thecode {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.codebox {
  margin-left: 30px;
}

.thecode img {
  width: 95px;
  height: 95px;
}

.thecode .names {
  width: 82px;
  font-size: 14px;
  margin-top: 13px;
  color: #aaaaaa;
  text-align: center;
}

.bottom {
  color: #909090;
  font-size: 14px;
  text-align: center;
  margin-top: 70px;
}
</style>